import { getState } from './state';
import { createSelector } from 'reselect';
export const getViewOptions = createSelector([
    getState
], (state)=>{
    var _state_viewOptions;
    return (_state_viewOptions = state.viewOptions) !== null && _state_viewOptions !== void 0 ? _state_viewOptions : {};
});
export const getActiveBucket = createSelector([
    getViewOptions
], (viewOptions)=>viewOptions.activeBucket);
export const getIsCategoryFilterApplied = createSelector([
    getActiveBucket
], (activeBucket)=>(activeBucket === null || activeBucket === void 0 ? void 0 : activeBucket.filterId) !== undefined);
export const getActiveFolder = createSelector([
    getViewOptions
], (viewOptions)=>viewOptions.activeFolder);
export const getShowShortcuts = createSelector([
    getViewOptions
], (viewOptions)=>viewOptions.showShortcuts);

//# sourceMappingURL=options.js.map